export default "__VITE_ASSET__2023ac7c__"